var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no-creatives-container"}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.$cdn + 'dist/assets/pointy-arrow.svg',"alt":""}})]),_c('div',{staticClass:"text-center"},[_c('div',[_vm._v("Looks like you don't have any "+_vm._s(_vm.type)+" yet")]),_c('div',[_vm._v("Add some here!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }